import "../../font.css.ts.vanilla.mjs";
import "./upload.css.ts.vanilla.mjs";
var p = "p273__upload-86ac_fc68edbc6__r8fvjo1", a = "p273__upload-86ac_fc68edbc6__r8fvjo0";
export {
  p as uploadListStyle,
  a as uploadStyle
};
//# sourceMappingURL=upload.mjs.map
